import axiosInstanceNew from "../lib/axiosinstanceNew";

const ClassnoteModal = class {

  
    async Add(data=[]){
        return(
            await axiosInstanceNew.post(`class_notes`,data)
        )
    }
    
    async get(id,iid){
        return(
            await axiosInstanceNew.get(`class_notes?type=${id}&class_id=${iid}`,)
        )
    }
    
}
export default new ClassnoteModal();